// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {356: "b70e8d8a3b",474: "7ecaf337df",489: "b70e8d8a3b",59: "f5cf642e22",721: "b70e8d8a3b",}[chunkId] + ".css"
}